import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
    name: 'liebherMarkAsUTC',
})
export class MarkAsUTCPipe implements PipeTransform {
    constructor() {}

    transform(value?: string): string | undefined {
        if (typeof value === 'string') {
            const _value = value?.includes('[GMT]') ? value?.replace('[GMT]', '') : value;
            return !_value || _value?.endsWith('Z') || _value?.endsWith('GMT') ? _value : _value + 'Z';
        } else {
            return value;
        }
    }
}
